export const SHOW_SUBSCRIBE_AS_EDUCATOR_MODAL =
  'SHOW_SUBSCRIBE_AS_EDUCATOR_MODAL';
export const TRIAL_COUNTDOWN_BANNER_CLICK = 'TRIAL_COUNTDOWN_BANNER_CLICK';
export const CLOSE_SUBSCRIBE_AS_EDUCATOR_MODAL =
  'CLOSE_SUBSCRIBE_AS_EDUCATOR_MODAL';
export const UPGRADE_EDUCATOR_TRIAL_SUBSCRIPTION_CLICK =
  'UPGRADE_EDUCATOR_TRIAL_SUBSCRIPTION_CLICK';

export const SOLUTIONS_SITE_LINK_CLICK = 'SOLUTIONS_SITE_LINK_CLICK';
